module.exports = __webpack_public_path__ + "static/img/curo-stain.a7ce9ab0.jpg";